export const paragraphs = {
    default: {
        fontSize: 's',
        lineHeight: 's',
        fontWeight: 'standard',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    emphasised: {
        fontSize: 's',
        lineHeight: 's',
        fontWeight: 'emphasised',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    compact: {
        fontSize: 's',
        lineHeight: 'xs',
        fontWeight: 'standard',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    compactEmphasised: {
        fontSize: 's',
        lineHeight: 'xs',
        fontWeight: 'emphasised',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    small: {
        fontSize: 'xs',
        lineHeight: 's',
        fontWeight: 'standard',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    smallEmphasised: {
        fontSize: 'xs',
        lineHeight: 's',
        fontWeight: 'emphasised',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    smallCompact: {
        fontSize: 'xs',
        lineHeight: 'xs',
        fontWeight: 'standard',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
    smallCompactEmphasised: {
        fontSize: 'xs',
        lineHeight: 'xs',
        fontWeight: 'emphasised',
        textDecoration: 'none',
        letterSpacing: 'normal',
    },
};
//# sourceMappingURL=paragraphs.js.map